import { ArtboardIcon } from './ArtboardIcon';

/**
 * author: Sintija
 * id 11D80B18-006C-4929-8CEA-29D2C8BED5B7
 * name artboard
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/artboard.svg
 * tags
 * - Drawing / Art 
 */
export const FrameIcon = ArtboardIcon;
export default FrameIcon